import React from "react";
import { Box, Button, Tooltip } from "@common-ui/ui";
import { Edit, DeleteForever } from "@mui/icons-material";
import { DataGridPro, LicenseInfo, GridToolbar } from "@mui/x-data-grid-pro";
import { capitalize } from "lodash";
import moment from "moment";
import { useHistory } from "react-router-dom";

LicenseInfo.setLicenseKey(process.env.REACT_APP_DATA_GRID_LICENSE);

export const ServiceTableView = (props) => {
  let router = useHistory();
  const columns = [
    {
      field: "name",
      headerName: "Service Name",
      flex: 1,
      renderCell: (params) => {
        return params.value ? params.value : "---";
      },
    },
    {
      field: "category",
      headerName: "Service Category",
      flex: 1,
      renderCell: (params) => {
        return params.value ? capitalize(String(params.value)) : "---";
      },
    },
    {
      field: "create_date",
      headerName: "Create Date",
      flex: 1,
      renderCell: (params) => {
        return params.value
          ? // <Link href={params.value} target="_blank">
            moment(params.value).format("YYYY-MM-DD LT")
          : // </Link>
            "---";
      },
    },
    {
      field: "update_date",
      headerName: "Update Date",
      flex: 1,
      renderCell: (params) => {
        return params.value
          ? // <Link href={params.value} target="_blank">
            moment(params.value).format("YYYY-MM-DD LT")
          : // </Link>
            "---";
      },
    },
    {
      field: "system_id",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => {
        return (
          <Box>
            <Tooltip title="Edit Service">
              <Button
                size="small"
                sx={{ fontWeight: 200 }}
                startIcon={<Edit size="small" />}
                onClick={() =>
                  router.push({
                    pathname: `/services/${params.row.orgId}/${params.value}/edit`,
                  })
                }
              >
                Edit
              </Button>
            </Tooltip>
            <Tooltip title="Remove Service">
              <Button
                size="small"
                startIcon={<DeleteForever size="small" />}
                sx={{ ml: 2, fontWeight: 200 }}
                onClick={() => {
                  props.setCurrentOrgId(params.row.orgId);
                  props.setCurrentMaintenancePlanId(params.value);
                  props.setOpenRemoveDialog(true);
                }}
              >
                Remove
              </Button>
            </Tooltip>
          </Box>
        );
      },
    },
  ];
  return (
    <>
      <Box
        component="main"
        sx={{
          alignItems: "center",
          display: "flex",
          flexGrow: 1,
          minHeight: "100%",
          backgroundColor: "#FFFFFF",
          ".MuiDataGrid-virtualScroller": {
            marginTop: "40px !important",
          },
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
        }}
      >
        <DataGridPro
          getRowId={(row) => row.system_id}
          // checkboxSelection
          sx={{
            border: 0,
            ".MuiDataGrid-columnSeparator": {
              display: "none",
            },
            "&.MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell:focus-within": {
              outline: "none !important",
            },
            ".MuiDataGrid-columnHeaders": {
              backgroundColor: "#F8F8F8",
              border: "1px solid #EBEBEB",
              minHeight: "40px !important",
              maxHeight: "40px !important",
              lineHeight: "40px !important",
            },
            ".MuiDataGrid-virtualScroller": {
              marginTop: "40px",
            },
          }}
          loading={props.isLoading}
          rows={props.data}
          // onCellDoubleClick={(props) => {
          //   router.push({
          //     pathname: `/customers/${props.id}/${props.row.orgId}`,
          //   });
          // }}
          density="comfortable"
          columns={columns}
          pagination
          components={{ Toolbar: GridToolbar }}
          disableSelectionOnClick
          autoHeight={true}
          // pinnedColumns={{ left: ["__check__"] }}
          // isRowSelectable={false}`
        />
      </Box>
    </>
  );
};
